// src/firebase.js
import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";

// Your Firebase config from console
const firebaseConfig = {
  apiKey: "AIzaSyBmeKGxedtJT4bpICk7JbAlH0-Cae7v4Co",
  authDomain: "gloginauth-45f80.firebaseapp.com",
  projectId: "gloginauth-45f80",
  appId: "1:290570002343:web:582aeb135899d671bd6082",
};

export const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
